import { useState } from "react";
import axios from "axios";

export default function MailSend() {
  const [file, setFile] = useState(null);
  const [template, setTemplate] = useState("");
  const [subject, setSubject] = useState("");
  const [perMessageDelayMs, setPerMessageDelayMs] = useState(1000);
  const [batchSize, setBatchSize] = useState(50);
  const [batchPauseMs, setBatchPauseMs] = useState(5000);

  const handleStart = async () => {
    if (!file) return alert("❌ Debes subir un Excel con los correos");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("template", template);
    formData.append("subject", subject);
    formData.append("perMessageDelayMs", perMessageDelayMs);
    formData.append("batchSize", batchSize);
    formData.append("batchPauseMs", batchPauseMs);

    try {
      await axios.post("/mail/start", formData);
      alert("✅ Envío iniciado");
    } catch (err) {
      alert("❌ Error iniciando envío");
    }
  };

  const handleAbort = async () => {
    try {
      await axios.post("/mail/abort");
      alert("🛑 Envío detenido");
    } catch {
      alert("❌ Error deteniendo envío");
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-4">Envío masivo de correos</h2>
      <input type="file" accept=".xlsx,.xls" onChange={(e) => setFile(e.target.files[0])} className="mb-4" />
      <input className="border p-2 mb-2 w-full" placeholder="Asunto del correo" value={subject} onChange={(e) => setSubject(e.target.value)} />
      <textarea className="border p-2 mb-2 w-full h-40" placeholder="Plantilla HTML" value={template} onChange={(e) => setTemplate(e.target.value)} />
      <div className="grid grid-cols-3 gap-2 mb-4">
        <input type="number" className="border p-2" placeholder="Delay por mensaje (ms)" value={perMessageDelayMs} onChange={(e) => setPerMessageDelayMs(e.target.value)} />
        <input type="number" className="border p-2" placeholder="Tamaño de lote" value={batchSize} onChange={(e) => setBatchSize(e.target.value)} />
        <input type="number" className="border p-2" placeholder="Pausa entre lotes (ms)" value={batchPauseMs} onChange={(e) => setBatchPauseMs(e.target.value)} />
      </div>
      <div className="flex gap-2">
        <button onClick={handleStart} className="bg-green-500 text-white px-4 py-2 rounded">Iniciar envío</button>
        <button onClick={handleAbort} className="bg-red-500 text-white px-4 py-2 rounded">Detener envío</button>
      </div>
    </div>
  );
}
